import Vue from 'vue';
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import App from './App.vue';
import basecss from './css/base.css'
import api from '../src/config'
import img_api from '../src/config'
//引入api接口
import API from "@/server/https.js";
Vue.prototype.$API = API;
Vue.use(ElementUI);
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  if ( to.path == '/products' ||to.path=='/participate'||to.path=='/projectCase'||to.path=='/performance'|| to.path == '/news'  || to.path == '/newsDetail' || to.path == '/tradeDetail' || to.path == '/operationDetail' || to.path == '/buildDetail' || to.path == '/contact') {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safaril
    window.pageYOffset = 0

  }
  next()
});
Vue.prototype.api = api;
Vue.prototype.img_api = img_api;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

